import React from 'react';
import { StandardPdfTemplate } from '../../templates/StandardPdfTemplate';
import { ProjectData, ProjectInfoData } from '../../shared/types/PdfCommonTypes';
import { IRailwayImages } from '../../../../services/PdfImageCaptureService';
import { TFunction } from 'i18next';
import { RailwayResultsCore } from './sections/RailwayResultsCore';

interface RailwayResultsPdfDocumentProps {
    railwayImages: IRailwayImages;
    dynamicProject: any;
    output: any;
    t: TFunction;
}

const RailwayResultsPdfDocumentV2: React.FC<RailwayResultsPdfDocumentProps> = ({ railwayImages, dynamicProject, output, t }) => {
    // Extract project information for header
    const projectData = dynamicProject?.data;
    const projectInfoData = projectData?.projectInfo;
    const projectMapImage = projectData?.mapImage;
    const projectType = projectData?.type || 'railways';

    // Prepare data for StandardPdfTemplate
    const projectDataForTemplate: ProjectData = {
        projectName: projectData?.projectName || 'N/A',
        projectType: projectType,
        unit: projectData?.unit || 'Metric',
        mapImage: projectMapImage,
    };

    const projectInfoDataForTemplate: ProjectInfoData = {
        data: {
            nrProject: projectInfoData?.data?.nrProject || 'N/A',
        },
        projectOwner: projectInfoData?.projectOwner || projectInfoData?.owner || 'N/A',
        designerFirmName: projectInfoData?.designerFirmName || 'N/A',
        designerFirmCountry: projectInfoData?.designerFirmCountry || 'N/A',
        designerFirmCity: projectInfoData?.data?.designerFirmCity || 'N/A',
        coordinates: projectInfoData?.coordinates || [null, null],
    };

    return (
        <StandardPdfTemplate
            projectType={projectType}
            projectData={projectDataForTemplate}
            projectInfoData={projectInfoDataForTemplate}
            t={t}
            headerConfig={{
                customTitle: t('pdf_header_technical_report_groundmac') || 'GROUNDMAC - Design Technical Report',
                customProjectType: t('project_type_railway') || 'Railway',
                customSubtitle: t('subtitle_railway') || 'Designing geogrid',
                showGeogridSubtitle: false,
            }}
            footerConfig={{
                customText: t('pdf_footer') || 'MACread eDesign',
                customNotice: t('pdf_footer_notice') || 'Footer notice',
            }}
            showProjectInfo={true}>
            {/* Use the shared core component for Railway Results */}
            <RailwayResultsCore railwayImages={railwayImages} projectData={projectData} output={output} t={t} showInputData={true} showResults={true} />
        </StandardPdfTemplate>
    );
};

export default RailwayResultsPdfDocumentV2;
